export default {
    name: "Additional",
    key: "Var_Additional",
    variables: [
        "newsletterBgColor",
        "newsletterFont",
        "headerIconsAndFontColor",
        "headerIconsAndFontColorHover",
        "headerCounterBgColor",
        "headerCounterBgColorHover",
        "headerCounterFontColor",
        "headerCounterFontColorHover",
        "headerCartIconAndFontColor",
        "headerCartIconAndFontColorHover",
        "topBannerBgColor",
        "topBannerFontColor",
        "topBannerFontHoverColor",
        "bannerFontColor",
        "bannerSecondaryFontColor",
        "bannerBtnBgColor",
        "bannerBtnFontColor",
        "bannerBtnHoverBgColor",
        "bannerBtnHoverFontColor",
        "bannerPromotionalFontColor",
        "bannerTimerBgColor",
        "bannerTimerBorderColor",
        "bannerTimerFontColor",
        "bannerTimerNumbersColor",
        "bannerTextFieldColor",
        "textElementBg",
        "textElementFont"
    ]
}